<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QUyhBX/image/1.png?1692049823933" alt="This image is the cover for the book Imagine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Imagine
      </h1>
      <p class="bookDescription body article font2">
        <p>This book will make you think twice about everyday things such as buttons, feet, a drop of water, a pumpkin, and an old slipper. This collection of stories will bring humour to everyday things and help to build your child’s imagination and help it to soar high. Follow the stories of these amazing everyday things and see their success. Your child will sleep peacefully knowing everything has a successful end.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pauline Margaret Edwards
      </h2>
      
      <p class="authorDescription body article">Pauline has a vivid imagination and sees stories behind everyday things, their variety of quirky stories. Her aim is for children’s imagination to reach for the sky, and apply their imagination to everyday things that have a story behind them and to show children there is always a story to be told.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ca6f0fc